import React from "react";
import Loader from "../../../../Common/Loader";
import { useAuthenticateIntegration } from "../hooks/useAuthenticateIntegration";

export function ConstantContactIntegrationReturnUrl() {
  const { code } = useAuthenticateIntegration({
    onSuccess: () => window.close(),
  });

  return (
    <div id="content">
      <Loader
        showLoader
        message={
          code
            ? "Authentication data has been received. You can close this window if it doesn’t close automatically."
            : "Cannot receive authentication data. Please close this window and retry."
        }
      />
    </div>
  );
}
